import { mapState, mapGetters } from 'vuex'
import { federatedTimelineVisible, publicTimelineVisible, bubbleTimelineVisible } from '../../lib/timeline_visibility'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUsers,
  faGlobe,
  faBookmark,
  faEnvelope,
  faChevronDown,
  faChevronUp,
  faComments,
  faBolt,
  faInfoCircle,
  faStream,
  faList,
  faBullhorn,
  faHome,
  faCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUsers,
  faGlobe,
  faBookmark,
  faEnvelope,
  faChevronDown,
  faChevronUp,
  faComments,
  faBolt,
  faInfoCircle,
  faStream,
  faList,
  faBullhorn,
  faHome,
  faCircle
)

const NavPanel = {
  components: {
  },
  data () {
    return {
      showTimelines: false
    }
  },
  methods: {
    toggleTimelines () {
      this.showTimelines = !this.showTimelines
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.users.currentUser,
      privateMode: state => state.instance.private,
      federating: state => state.instance.federating,
      publicTimelineVisible,
      federatedTimelineVisible,
      bubbleTimelineVisible,
    }),
    ...mapGetters(['unreadAnnouncementCount']),
    unreadDMConversationsCount () {
      return this.$store.state.users.currentUser?.pleroma?.unread_conversation_count || 0
    },
    followRequestCount () {
      return this.$store.state.users.currentUser.follow_requests_count
    }
  }
}

export default NavPanel
